import {urlSiteDevices} from './apiUrls'
import SecondServer from './SecondServer'
import { siteAccessCode } from './apiv2SiteAccessor';

export async function fetchSiteDevices (siteId, props) {
  const ss = new SecondServer(props);
  const respObj = await ss.apiDataObj (urlSiteDevices(siteId, 'Target'));
  return respObj;
}
// /tehama/sites/{access_code}/devices without an ac_type parameter to get
// source and target device lists. compare the two lists. if it's in source but
// not target, it's unconfigured.
export async function fetchSourceDevices (site, ss) {
  const url = urlSiteDevices(siteAccessCode(site), "Source")
  const jsonResponse = await ss.apiData (url);
  return jsonResponse
}
